import { CopyButton } from './copy-button'

/**
 * One DNS record the customer has to add, in the same shape everywhere it
 * appears (per-language rows in subdomain mode, the site panel in folder mode).
 *
 * Two lines rather than one: the value is a 36-character UUID, so a single row
 * either truncates it or forces a horizontal scroll on a phone. Line one is
 * what the record *is* (in the customer's words — never "custom hostname") and
 * whether we've seen it; line two is the literal text to paste.
 */
export interface DnsRecordLine {
	kind: 'CNAME' | 'TXT'
	/** What the record is for: "routing", "proves you own the domain", … */
	role: string
	name: string
	value: string
	found: boolean
}

export function RecordLine({ kind, role, name, value, found }: DnsRecordLine) {
	return (
		<div className="rounded-nayda-sm border border-line bg-paper px-3 py-2">
			<div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
				<span className="text-[11px] text-ink-soft">
					<span className="font-mono text-ink">{kind}</span> · {role}
				</span>
				<span className="flex items-center gap-2">
					{found ? (
						<span className="text-[12px] text-[#3F7D58]">✓ found</span>
					) : (
						<span className="text-[12px] text-ink-mute">waiting</span>
					)}
					{!found && <CopyButton value={`${name}\t${value}`} />}
				</span>
			</div>
			<div className="mt-1 break-all font-mono text-[12px] text-ink">
				{name} → {value}
			</div>
		</div>
	)
}

/** Clipboard shape for "Copy all missing" — one record per line, tab-separated. */
export function formatRecords(records: DnsRecordLine[]): string {
	return records.map((r) => `${r.kind}\t${r.name}\t${r.value}`).join('\n')
}
